import { render, staticRenderFns } from "./CreateVideoButton.vue?vue&type=template&id=66eed8a9"
import script from "./CreateVideoButton.vue?vue&type=script&lang=js"
export * from "./CreateVideoButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports